/**
 * Zod schema for status fields.
 * Message: Required "Select an option."
 */

import { z } from 'zod';
import type { FieldSchemaConfig } from '../types';

export function getStatusSchema(col: FieldSchemaConfig): z.ZodTypeAny {
  const required = 'required' in col && col.required === true;

  if (required) {
    return z
      .any()
      .refine(
        (v: unknown) => v !== null && v !== undefined && v !== '',
        'Select an option.'
      ) as z.ZodTypeAny;
  }
  return z.any();
}
